<template>
  <div id="loader" v-if="isLoaderActive">
    <v-row class="board">
      <v-col cols="12">
        <v-progress-circular indeterminate
          class="mb-4"
          color="white"
          :size="70"
        />
      </v-col>
      <v-col cols="12">
        <p class="body-2">{{ printLoaderMessage }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'loader',
  computed: {
    isLoaderActive () {
      return this.$store.getters['loader/isActive']()
    },
    printLoaderMessage () {
      return this.$store.getters['loader/printMessage']()
    }
  }
}
</script>

<style lang="scss">
#loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, .4);
  color: #FFF;
  z-index: 99;

  .board {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 200px;
    height: 200px;
    text-align: center;
    background: rgba(#000, .8);
    border-radius: 2px;
    padding-top: 50px;
    .icon {
      font-size: 8rem;
    }
  }
}
</style>
